import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import ScrollToTopOnMount from '../components/ScrollToTopOnMount';
import HomePage from '../pages/HomePage';
import WorkPage from '../pages/WorkPage';
import WorkDetailPage from '../pages/WorkDetailPage';
import ErrorNotFoundPage from '../pages/ErrorNotFoundPage';

const Routes = () => (
  <Router>
    <Switch>
      <ScrollToTopOnMount>
        <Route exact path="/" component={HomePage} />
        <Route exact path="/work" component={WorkPage} />
        <Route exact path="/work/:project" component={WorkDetailPage} />
        <Route component={ErrorNotFoundPage} />
      </ScrollToTopOnMount>
    </Switch>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/util/Routes.js